export function escapeRegExp(string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function replaceAll(
    str: string,
    search: string,
    replacement: string
): string {
    return str.replace(new RegExp(escapeRegExp(search), 'g'), replacement);
}

export function getFieldLimits(colDef) {
    const params = colDef.cellEditorParams;
    //Generic 'invalid' message for when ew have nothing
    if (!params) {
        return 'invalid';
    }

    //Numeric range errors
    if (
        params.min !== null &&
        params.min !== undefined &&
        params.max !== null &&
        params.max !== undefined
    ) {
        return 'outside the range of ' + params.min + ' to ' + params.max;
    }
    if (params.min !== null && params.min !== undefined) {
        return 'lower than the minimum of ' + params.min;
    }
    if (params.max !== null && params.max !== undefined) {
        return 'higher than the maximum of ' + params.max;
    }

    //Generic 'invalid' message for errors we don't handle yet
    return 'invalid';
}
